<script>
  import { cn } from '@lib/utils'
  import { watch } from 'runed'

  let {
    prefix,
    suffix,
    children,
    value = $bindable(""),
    class: className,
    validate: validateOn = "blur",
    onValidate,
    inputClass = "",
    prefixClass = "",
    suffixClass = "", 
    ...restProps
  } = $props()

  let inputRef = $state(null)
  let errorMessage = $state(null)
  let valid = $derived(!errorMessage)
  let hasAdornment = $derived(!!prefix || !!suffix)

  export function focus() {
    inputRef?.focus()
  }

  export function blur() {
    inputRef?.blur()
  }

  function oninput() {
    if (errorMessage || validateOn === "input") {
      validate()
    }
  }

  function onblur() {
    validateOn === "blur" && validate()
  }

  function validate() {
    const validity = inputRef?.validity
    errorMessage = (validity.patternMismatch && patternMessage) ? patternMessage : inputRef.validationMessage
  }

  // Use watch to see when error value changes
  watch(() => valid, (newValid) => {
    onValidate?.(valid, { message: errorMessage })
  })

</script>

<div class={cn("input-container", hasAdornment && "has-adornment", valid ? "" : "border border-red-600/80 focus-within:ring-0")}>
  {#if prefix}
    <div class={cn(prefixClass)}>{@render prefix()}</div>
  {/if}
  {#if children}
    {@render children()}
  {:else}
    <input bind:this={inputRef} class="input autofill:bg-transparent flex-1 w-full" {oninput} {onblur} bind:value={value} {...restProps} />
  {/if}
  {#if suffix}
    <div class={cn(suffixClass)}>{@render suffix()}</div>
  {/if}
</div>

{#if errorMessage}
  <p class="pl-1 text-[11px] text-red-600/80 error-text">{errorMessage}</p>
{/if}
